import React from 'react';
import Complaints from '../components/Complaint/Complaints';

const Complaint = () => {
    return ( <Complaints/> );
}
 
export default Complaint;